import { createClient } from "contentful";

const client = createClient({
  space: "lr49fpmivbaf", // Replace with your Space ID
  accessToken: "57QalNIxNpFcvriZGaG2cGmiOInzUc6VogCcgs37Fho", // Replace with your Access Token
});

export default client;
